import React from "react";
import { Perfil } from "../../../../models/enum";
import { useUsuario } from "../../../../providers/usuarioProvider";

type Props = {
  renderInvestidor?: React.ReactElement;
  renderContador?: React.ReactElement;
};

export default function PerfilSwitch({
  renderInvestidor = <></>,
  renderContador = <></>,
  ...props
}: Props) {
  const { isLoading, claims } = useUsuario();
  if (isLoading) return <></>;
  switch (claims?.perfil) {
    case Perfil.INVESTIDOR:
      return React.cloneElement(renderInvestidor, {
        key: renderInvestidor.key,
        ...props,
        ...renderInvestidor.props,
      });
    case Perfil.CONTADOR:
      return React.cloneElement(renderContador, {
        key: renderContador.key,
        ...props,
        ...renderContador.props,
      });

    default:
      return <></>;
  }
}
